import apiClient from "../base/apiClient";

export const orderApi = {
    getOrderList: async (resource: string, params: any) => {
    const { page = 0, perPage = 10} = params.pagination || {};
    const { fulfilledByIds , flowIds , postedByIds, filter  } = params.filter;
    
    const requestBody = {
        fulfilledByIds,
        flowIds,
        postedByIds,
        page: page.toString(),
        count: perPage,
        filter
    };
    
    const response = await apiClient.post(
        `/Administration/Order/QueryOrders`,
        requestBody,
        {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        },
        }
    );
    
    if (response.data.errorMessage) {
        throw new Error(response.data.errorMessage);
    }
    if (response.data.error) {
        throw new Error(response.data.error);
    }
    
    const orders = response.data.orders || [];
        return {
            data: orders.map((order: any) => ({
            id: order.orderId || order.id,
            ...order,
            })),
            total: response.data.total,
        };
    },
}    